import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertService } from 'src/app/core/services/alert.service';

@Component({
  selector: 'app-alarm-modal',
  templateUrl: './alarm-modal.component.html',
  styleUrls: ['./alarm-modal.component.scss'],
})
export class AlarmModalComponent implements OnInit {
  constructor(public modalService: NgbModal, private alertService: AlertService) {}

  ngOnInit() {}

  modalClose() {
    this.modalService.dismissAll();
  }

  // 모두 읽기
  allRead() {
    console.log('읽음처리!');
  }

  // 전체 삭제
  allDelete() {
    this.alertService.successConfirm('모든 알림을 삭제하시겠습니까?');
  }
}
